/* ── Prevent re-adding items already in the cart via quick-add ── */
(function () {
  var IN_CART_CLASS = 'quick-add--in-cart';
  var IN_CART_LABEL_CLASS = 'qa-in-cart-label';
  var IN_CART_TEXT = 'הפריט כבר בעגלת הקניות';

  var cartVariantIds = new Set();

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartVariantIds = new Set(cart.items.map(function (item) {
          return String(item.variant_id);
        }));
        syncAllQuickAdds();
      })
      .catch(function () {});
  }

  function syncAllQuickAdds() {
    document.querySelectorAll('quick-add-component').forEach(syncOne);
  }

  function syncOne(qa) {
    var variantInput = qa.querySelector('input[name="id"]');
    if (!variantInput) return;

    var inCart = cartVariantIds.has(variantInput.value);

    qa.querySelectorAll('button').forEach(function (btn) {
      btn.disabled = inCart;
      btn.setAttribute('aria-disabled', inCart ? 'true' : 'false');
      btn.classList.toggle(IN_CART_CLASS, inCart);
    });

    var form = qa.querySelector('form');
    if (form) {
      if (inCart) {
        form.dataset.cartBlocked = '1';
      } else {
        delete form.dataset.cartBlocked;
      }
    }

    var label = qa.querySelector('.' + IN_CART_LABEL_CLASS);
    if (inCart && !label) {
      var el = document.createElement('p');
      el.className = IN_CART_LABEL_CLASS;
      el.setAttribute('dir', 'rtl');
      el.setAttribute('aria-live', 'polite');
      el.textContent = IN_CART_TEXT;
      qa.appendChild(el);
    } else if (!inCart && label) {
      label.remove();
    }
  }

  // Block form submission before Horizon's handler gets it
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.dataset.cartBlocked) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Block clicks on already-in-cart buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('quick-add-component button');
    if (btn && btn.classList.contains(IN_CART_CLASS)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Watch for quick-add-components added to DOM after page load (AJAX sections)
  var observer = new MutationObserver(function (mutations) {
    var found = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('quick-add-component')) {
          syncOne(node);
          found = true;
        } else if (node.querySelectorAll) {
          var children = node.querySelectorAll('quick-add-component');
          if (children.length) {
            children.forEach(syncOne);
            found = true;
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', fetchCart);
  document.addEventListener('cart:updated', fetchCart);
  document.addEventListener('cart:refresh', fetchCart);
})();

/* ── Locale-aware internal link routing ── */
(function () {
  var primaryLocale = 'he';

  function getActiveLocale() {
    return document.documentElement.lang || primaryLocale;
  }

  function isInternalLink(href) {
    if (!href) return false;
    if (href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return false;
    if (href.startsWith('http://') || href.startsWith('https://')) {
      return href.indexOf(window.location.hostname) !== -1;
    }
    return true;
  }

  function addLocalePrefix(href, locale) {
    var prefix = '/' + locale;
    // Strip hostname if absolute
    if (href.startsWith('http')) {
      var url = new URL(href);
      href = url.pathname + url.search + url.hash;
    }
    // Already prefixed
    if (href === prefix || href.startsWith(prefix + '/')) return href;
    return prefix + (href.startsWith('/') ? href : '/' + href);
  }

  document.addEventListener('click', function (e) {
    var locale = getActiveLocale();
    if (locale === primaryLocale) return; // Hebrew is primary — no prefix needed

    var link = e.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!isInternalLink(href)) return;

    // Skip links that already have the locale prefix
    var prefix = '/' + locale;
    if (href === prefix || href.startsWith(prefix + '/') || href.startsWith(prefix + '?')) return;

    e.preventDefault();
    window.location.href = addLocalePrefix(href, locale);
  }, true);
})();

/* ── Language switcher: flags only, no text ── */
(function () {
  function buildFlagSwitcher(select) {
    var flags = window.glFlags || {};
    var options = Array.from(select.options);

    var container = document.createElement('div');
    container.className = 'gl-flags-only';

    options.forEach(function (opt) {
      var lang = opt.getAttribute('lang') || opt.value;
      var flagUrl = flags[lang];
      if (!flagUrl) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gl-flag-btn' + (opt.selected ? ' gl-flag-btn--active' : '');
      btn.setAttribute('title', opt.textContent.trim());
      btn.setAttribute('aria-label', opt.textContent.trim());

      var img = document.createElement('img');
      img.src = flagUrl;
      img.alt = opt.textContent.trim();
      img.className = 'gl-lang-flag';
      img.width = 26;
      img.height = 18;
      btn.appendChild(img);

      btn.addEventListener('click', function () {
        if (opt.selected) return;
        select.value = lang;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });

      container.appendChild(btn);
    });

    // Hide the native select wrapper, insert flags before it
    var wrapper = select.closest('.language-selector') || select.parentNode;
    wrapper.parentNode.insertBefore(container, wrapper);
    wrapper.style.display = 'none';
  }

  function initFlagSwitchers() {
    document.querySelectorAll('select[name="language_code"]').forEach(buildFlagSwitcher);
  }

  document.addEventListener('DOMContentLoaded', initFlagSwitchers);
})();
